import { format } from 'date-fns';

import { DateType } from '@utils/dateUtil';

export const URL_DATE_FORMAT = 'yyyy-MM-dd';

export const formatDateForUrl = (date: DateType) => {
  if (!date) return null;

  return format(date.toDate(), URL_DATE_FORMAT);
};
